class DeleteAiCostLimit {
	constructor(
		public readonly accountId: number,
		public readonly limitId: number,
	) {
		Object.freeze(this);
	}
}

export default DeleteAiCostLimit;
